import React, { Component } from "react";
import MediaQuery from "react-responsive";
import withRouter from "../utils/withRouter";
import Layout from "./../layouts/Main";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCategoryById } from "./../store/actions/CategoryActions";
import { getMoqsByCategoryId, getMoreMoqsByCategoryId } from "./../store/actions/MoqActions";
import MOQ from "./../components/MOQ";
import instance from "../utils/instance";
import ContentLoader from "react-content-loader";
import { Helmet } from "react-helmet-async";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarouselMobile from "./../components/SliderMobile";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Pagination from "../components/Pagination";

const BlockLoader = ({
  height = 300,
  width = "100%",
  radius = 8,
  uniqueKey = "unique",
}) => (
  <ContentLoader
    uniqueKey={uniqueKey}
    speed={2}
    width={width}
    height={height}
    backgroundColor="#ECEBEB"
    foregroundColor="#b0b0b0"
  >
    <rect
      x="0"
      y="0"
      rx={`${radius}`}
      ry={`${radius}`}
      width="100%"
      height={`${height}`}
    />
  </ContentLoader>
);

const settings = {
  dots: true,

  autoplay: true,

  infinite: true,

  speed: 500,

  slidesToShow: 1,

  slidesToScroll: 1,

  arrows: false,

  appendDots: (dots) => (
    <div
      style={{
        position: "absolute",

        bottom: "10px",

        borderRadius: "10px",

        padding: "10px",
      }}
    >
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
};

class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,

      categoryId: null,

      loading_trending_promotions: false,

      loading: false,

      promotion: null,

      promotions: [],

      trending: [],

      data: [],
    };

    this.scrollerRef = React.createRef();
    
    window.onscroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight
      ) {
        // this.fetchMoreMoqs()
      }
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true, loading_trending_promotions: true });

    const {
      params: { id },
    } = this.props;

    const response = await this.props.getCategoryById(id);

    if (response) {
      this.setState({categoryId: response?.id})
      try {
        if (window.innerWidth < 768) {
          await this.getTrending(response?.id);
        }
        await this.getPromotions();
        this.setState({ loading_trending_promotions: false });
      } catch (e) {
        console.error("Failed to load trending or promotions", e);
        this.setState({ loading_trending_promotions: false });
      }
      await this.props.getMoqsByCategoryId(this.state.categoryId, this.state.page);

    }

    this.setState({ loading: false });
  };

  fetchMoreMoqsByCatId = async () => {
    try {
      this.setState({ loading: true });

      const {
        moqs: { next_page, pages },
      } = this.props;

      if (!next_page) {
        this.setState({ loading: false });
        return;
      }

      if (next_page > pages) {
        this.setState({ loading: false });
        return;
      }

      const result = await this.props.getMoreMoqsByCategoryId(this.state.categoryId, next_page);
      this.setState({ loading: false });

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };

  handlePageClick = async (page) => {
    try {
      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      const { moqs: { pages, page: current_page } } = this.props
      if (page >= 1 && page <= pages && page !== current_page) {
        this.setState({ page: page, loading: true })
        await this.props.getMoqsByCategoryId(this.state.categoryId, page);
      }
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.log(error)
    }
  };

  async handleScroll() {
    const scroller = this.scrollerRef.current;
    if (scroller.scrollHeight - scroller.scrollTop === scroller.clientHeight) {
      await this.fetchMoreMoqsByCatId()
    }
  }

  getPromotions = async (id) => {
    try {
      let result = await instance.get(`category_promotions`);

      if (result?.data) {
        this.setState({ promotions: result?.data?.promotions });
      }
    } catch (e) {
      console.log(e);
    }
  };

  getTrending = async (category_id) => {
    try {
      const result = await instance.get("moq/trending?category_id=" + category_id);
      if (result?.data?.moqs) {
        this.setState({ trending: result.data.moqs });
      }
    } catch (e) {
      console.error("Failed to load trending", e);
    }
  };

  render() {
    const {
      moqs: { moqs, pages, total_count, page_count },
      categories: { category },
    } = this.props;
    const { loading, loading_trending_promotions, promotions, trending } = this.state;

    let promos =
      promotions.filter(
        (promo) => promo?.category_id === parseInt(category?.id)
      ) || [];

    return (
      <Layout>
        <Helmet prioritizeSeoTags>
          <meta charSet="utf-8" />

          <title>{`Litudian ${
            category && typeof category !== "object" && category.name !== null
              ? ` | ${category.name}`
              : ""
          }`}</title>
          <meta name="description" content={`${category?.name}`}></meta>

          <link rel="canonical" href={`https://www.litudian.com/categories/${category?.slug}`}></link>

          <link rel="icon" href="/favicon.ico" />
        </Helmet>

        <div className="flex flex-col">
          {loading_trending_promotions && (
            <BlockLoader
              uniqueKey="carousel"
              height={400}
              width={"100%"}
            />
          )}
          {!loading_trending_promotions && promos && promos.length > 0 && (
          <><MediaQuery minWidth={768} >
            <Slider {...settings}>
              {promos.map((promo, i) => (
                <div key={i} className="h-[400px]">
                  <div className="flex flex-col relative h-full">
                    <LazyLoadImage
                      className="w-full object-cover h-full"
                      src={promo.image_url}
                      alt={promo.title}
                    />

                    <div className="absolute top-0 left-0 bg-black/10 flex flex-1 flex-col justify-end items-center w-full p-10 h-full space-y-4">
                      <h3 className="text-white text-4xl font-bold">
                        {promo.title}
                      </h3>

                      <p className="text-white text-lg font-bold">
                        {promo.description}
                      </p>
                    </div>

                    {promo?.item_url && promo?.item_url !== "" && (
                      <div
                        onClick={() =>
                          window.location.href === `${promo?.item_url}`
                        }
                        className="absolute top-0 left-0 bg-transparent z-10 rounded-md flex flex-1 flex-col justify-end items-center w-full p-10 h-full space-y-4 cursor-pointer"
                      ></div>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
              <CarouselMobile trending={trending} />
          </MediaQuery></>
          )}

          <h1 className="text-[#A68F69] dark:text-tangerine font-bold capitalize mt-5 flex flex-wrap items-center gap-2">
            {category !== null && category.name}

            {(this.state.page && pages > 0) && (
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                (Page {this.state.page} of {pages}
                  {total_count > 0 && ` • Showing ${page_count || moqs.length} of ${total_count} Products`}
                )
              </span>
            )}
          </h1>

          <div 
            ref={this.scrollerRef}
            onScroll={this.handleScroll}
            className="grid grid-cols-2 md:grid-cols-6 gap-4 py-5">

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {loading && (
              <BlockLoader uniqueKey="key1" height={250} radius={6} />
            )}

            {!loading && moqs && moqs.map((moq, i) => <MOQ key={i} moq={moq} />)}
          </div>

          {!loading && moqs === undefined && (
            <div className="flex flex-col justify-center items-center w-full min-h-[200px]">
              <h1 className="text-[#A68F69] dark:text-tangerine">
                No Products Available
              </h1>
            </div>
          )}
        </div>
        <div className="flex flex-row justify-center items-center py-8 mt-16">
          <Pagination
            currentPage={this.state.page}
            totalPages={pages}
            onPageChange={this.handlePageClick}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    moqs: state.moqs,

    categories: state.categories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getMoqsByCategoryId, getCategoryById, getMoreMoqsByCategoryId }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Categories));
